import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { GenericPagingVM, CounsellorSearchRequestVM } from '../../../models';
import { SearchService } from '../../../services/search.service';

@Component({
  selector: 'search',
  templateUrl: './search.component.html'
})
export class SearchComponent extends BaseComponent implements OnInit {

  request: CounsellorSearchRequestVM;

  constructor(
    private searchService: SearchService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router) {
    super(route);
  }

  ngOnInit(): void {
    if (this.searchService.searchRequest == null)
      this.searchService.searchRequest = new CounsellorSearchRequestVM();

    this.request = this.searchService.searchRequest;
    //ensure continuation token is empty
    this.request.continuationToken = '';

    this.myForm = this.fb.group({
      counsellorName: new FormControl(this.request.counsellorName),
      gender: new FormControl(null),
      language: new FormControl(this.request.language),
      country: new FormControl(this.request.country),
      state: new FormControl(null),
      counsellingTopic: new FormControl(this.request.counsellingTopic),
      sessionType: new FormControl(null),
      availability: new FormControl(null)
    });
  }

  onSubmit(value: string) {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.searchService.initSearch(this.request)
        .subscribe(returnValue => {
          if (returnValue) {
            this.router.navigateByUrl('/results');
          }
        });
    }
  }

}
